import React from 'react';
import {} from 'prop-types';
import cx from 'classnames';

import { PageSection } from '../';

const CLASS_ROOT = 'footer';

const propTypes = {};

const Footer = ({ className, children, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  return (
    <footer className={classes} {...other}>
      <PageSection type="transparent" space="large">
        {children}
      </PageSection>
    </footer>
  );
};

Footer.propTypes = propTypes;

export default Footer;
